module.exports = __webpack_public_path__ + "img/bot_sz2.870260f5.png";